var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSector = function SvgSector(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.679 15.857q.321 0 .321.321v.536H4v-.536q0-.32.321-.32h.536V3.641a.62.62 0 0 1 .188-.454A.62.62 0 0 1 5.5 3h9a.62.62 0 0 1 .454.188.62.62 0 0 1 .188.456v12.213zM7.429 5.036v1.072q0 .32.32.32h1.073q.32 0 .32-.32V5.034q0-.319-.32-.32H7.749q-.32 0-.32.322m0 2.571v1.072q0 .321.32.321h1.073q.32 0 .32-.321V7.606q0-.321-.32-.321H7.749q-.321 0-.322.32zm1.393 3.965q.32 0 .32-.322v-1.072q0-.32-.32-.32H7.749q-.321 0-.322.32v1.072q0 .322.322.322H8.82m2.035 4.285v-2.25q0-.321-.321-.321H9.463q-.321 0-.321.321v2.25zm1.714-4.607v-1.072q0-.32-.32-.32h-1.073q-.32 0-.32.32v1.072q0 .322.32.322h1.072q.321 0 .321-.322m0-2.571V7.606q0-.321-.32-.321h-1.073q-.32 0-.32.32v1.073q0 .321.32.321h1.072q.321 0 .321-.321zm0-2.571V5.034q0-.32-.32-.32h-1.073q-.32 0-.32.32v1.072q0 .322.32.322h1.072q.321 0 .321-.322z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSector);
export default ForwardRef;